import { complianceApi } from '~/shared/services/api';
import { EmployeeDetailsDto } from '../dto/employee-details.dto';

export const fetchEmployeeDetailsByEmployeeId = async (
  id: string
): Promise<EmployeeDetailsDto> => {
  const response = await complianceApi.get<EmployeeDetailsDto>(
    `/employees/by-id/${encodeURIComponent(id)}`
  );
  return response.data;
};
